export default "__VITE_ASSET__tih$gZtT__"